import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import CopyCard from "../components/CopyCard";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faPlus, faXmark, faCircleNotch} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import Select from "react-select";

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Copyexpert() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [disable1, setDisable1] = useState(true);
  const [trader_photo, setTrader_photo] = useState();
  const [trader_name, setTrader_name] = useState();
  const [win, setWin] = useState();
  const [loss, setLoss] = useState();
  const [win_rate, setWin_rate] = useState();
  const [profit_share, setProfit_share] = useState();
  const [price, setPrice] = useState();
  const [aum, setAum] = useState();
  const [copiers, setCopiers] = useState();
  const [mock, setMock] = useState();
  const [totalCopiers, setTotalCopiers] = useState();
  const [pnl, setPnl] = useState();
  const [margin, setMargin] = useState();
  const [lock, setLock] = useState();
  const [min, setMin] = useState();
  const [ninetyRatio, setNinetyRatio] = useState();
  const [sevenRatio, setSevenRatio] = useState();
  const [thirtyRatio, setThirtyRatio] = useState();
  const [ninetyPnl, setNinetyPnl] = useState();
  const [sevenPnl, setSevenPnl] = useState();
  const [thirtyPnl, setThirtyPnl] = useState();
  const [ninetyRoi, setNinetyRoi] = useState();
  const [sevenRoi, setSevenRoi] = useState();
  const [thirtyRoi, setThirtyRoi] = useState();
  const [ninetyProfit, setNinetyProfit] = useState();
  const [sevenProfit, setSevenProfit] = useState();
  const [thirtyProfit, setThirtyProfit] = useState();
  const [ninetyPosition, setNinetyPosition] = useState();
  const [sevenPosition, setSevenPosition] = useState();
  const [thirtyPosition, setThirtyPosition] = useState();
  const [ninetyMdd, setNinetyMdd] = useState();
  const [sevenMdd, setSevenMdd] = useState();
  const [thirtyMdd, setThirtyMdd] = useState();
  const [ninetyWinRate, setNinetyWinRate] = useState();
  const [sevenWinRate, setSevenWinRate] = useState();
  const [thirtyWinRate, setThirtyWinRate] = useState();
  const [description, setDescription] = useState();
  const [rank, setRank] = useState();
  const [portfolio, setPortfolio] = useState();
  const [join, setJoin] = useState();
  const [files, setFiles] = useState([]);
  const [badge_color, setBadge_color] = useState();
  const badgeoption = [
    { value: 'blue', label: 'Blue' },
    { value: 'gold', label: 'Gold' }
  ];
  useEffect(() => {
    if(trader_photo && trader_name && win && loss && win_rate && profit_share && price && badge_color && description && aum && copiers && join){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [trader_photo, trader_name, win, loss, win_rate, profit_share, price, badge_color, description, aum, copiers, join]);
  useEffect(() => {
    if(mock && totalCopiers && min && ninetyRatio && lock && margin && pnl && sevenRatio && thirtyRatio && ninetyPnl && sevenPnl && thirtyPnl && ninetyRoi && sevenRoi && thirtyRoi && ninetyProfit && sevenProfit && thirtyProfit && ninetyPosition && sevenPosition && thirtyPosition && ninetyMdd && sevenMdd && thirtyMdd && ninetyWinRate && sevenWinRate && thirtyWinRate && rank && portfolio){
      setDisable1(false);
    }else{
      setDisable1(true);
    }
  }, [mock, totalCopiers, min, ninetyRatio, lock, margin, pnl, sevenRatio, thirtyRatio, ninetyPnl, sevenPnl, thirtyPnl, ninetyRoi, sevenRoi, thirtyRoi, ninetyProfit, sevenProfit, thirtyProfit, ninetyPosition, sevenPosition, thirtyPosition, ninetyMdd, sevenMdd, thirtyMdd, ninetyWinRate, sevenWinRate, thirtyWinRate, rank, portfolio]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [copyExperts, setCopyExperts] = useState([]);
  const [myCopy, setMyCopy] = useState([]);
  function safeJSONParse(value) {
    try {
        return typeof value === "string" ? JSON.parse(value) : value;
    } catch {
        return value || {};
    }
  }
  useEffect(() => {
    const fetchCopyData = async () => {
    try {
      const myCopyRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchMyCopytrade: true })
      });
      const myCopyData = await myCopyRes.json();
      if (myCopyData.status !== "success") {
        toast.error('Error fetching your copytrade data!');
        return;
      }
      const myCopyList = myCopyData.copytrade;
      setMyCopy(myCopyList);
      const allExpertsRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fetchCopytrade: true })
      });
      const allExpertsData = await allExpertsRes.json();
      if (allExpertsData.status !== "success") {
        toast.error('Error fetching expert traders!');
        return;
      }
      const expertList = allExpertsData.copytrade;
      const updatedExperts = expertList.map(trader => {
        const myCopy = myCopyList.find(
          item => item.trader_id === trader.trade_id
        );
        const info = trader.info || {};
        return {
          ...trader,
          copy: !!myCopy,
          pending: myCopy?.status == 2,
          info: {
            ...info,
            seven: safeJSONParse(info.seven),
            thirty: safeJSONParse(info.thirty),
            ninety: safeJSONParse(info.ninety),
          }
        };
      });
      setCopyExperts(updatedExperts);
    } catch (err) {
      toast.error('An unexpected error occurred!');
    }
  };
    if (user) {
      fetchCopyData();
    }
  }, [user]);
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const AddCopytrade = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/copytrade.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addcopytrade: true, trader_photo : trader_photo, trader_name : trader_name, win : win, loss : loss, win_rate : win_rate, profit_share : profit_share, price : price, badge_color: badge_color, description: description, aum: aum, copiers: copiers, join: join, mock: mock, totalCopiers: totalCopiers, min: min, lock: lock, margin: margin, pnl: pnl, ninetyRatio: ninetyRatio, sevenRatio: sevenRatio, thirtyRatio: thirtyRatio, ninetyPnl: ninetyPnl, sevenPnl: sevenPnl, thirtyPnl: thirtyPnl, ninetyRoi: ninetyRoi, sevenRoi: sevenRoi, thirtyRoi: thirtyRoi, ninetyProfit: ninetyProfit, sevenProfit: sevenProfit, thirtyProfit: thirtyProfit, ninetyPosition: ninetyPosition, sevenPosition: sevenPosition, thirtyPosition: thirtyPosition, ninetyMdd: ninetyMdd, sevenMdd: sevenMdd, thirtyMdd: thirtyMdd, ninetyWinRate: ninetyWinRate, sevenWinRate: sevenWinRate, thirtyWinRate: thirtyWinRate, rank: rank, portfolio: portfolio })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "copyexpert";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Copy Experts" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Copy Experts" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="d-flex align-items-center justify-content-between mt-2">
              <div className="ms-2">
                <h6 className="mb-0 text-white mt-3 text-uppercase" style={{fontSize:'20px', fontWeight:'900'}}>Copy Trading</h6>
                <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Follow the top crypto traders and copy their trades in real time. Just hit the Copy button.</p>
              </div>
              {user?.user_type === "adminface" && (
                <div className="myBtn d-inline-block bg-prime px-3" style={{fontSize: '14px'}} onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> Add Expert</div>
              )}
            </div>
            <div className="row">
              {copyExperts.map((expert) => (
                <div className="col-xxl-3 col-lg-4 col-6 col-12 g-4">
                    <CopyCard key={expert.id} trade_id={expert.trade_id} pending={expert.pending} info={expert.info} photo={expert.trader_photo} image={<img src={`/uploads/${expert.trader_photo}`} alt={expert.trader_name} style={{height:'100%',width:'100%',objectFit:'cover'}} />} name={expert.trader_name} winrate={expert.win_rate} profit={expert.profit_share} win={expert.win} loss={expert.loss} copy={expert.copy} price={expert.price} badge_color={expert.badge_color}/>
                </div>
              ))}
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add expert</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Expert image</label>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={false}
              maxFiles={3}
              name="file"
              labelIdle="Click here to upload payment proof"
              server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                  const formData = new FormData();
                  formData.append("file", file);
                  const request = new XMLHttpRequest();
                  request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                      setTrader_photo(res.filename);
                      load(res.filename);
                    } else {
                      error(res.error || "Upload failed");
                    }
                  };
                  request.onerror = () => {
                    error("Upload error");
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    }
                  };
                },
                revert: (serverId, load, error) => {
                  fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: trader_photo })
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        setTrader_photo("");
                        setFiles([]);
                        load();
                      } else {
                        error(data.error || "Failed to delete file");
                      }
                    })
                    .catch(() => {
                      error("Delete request failed");
                    });
                }
              }}
            />
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Expert Name:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="Gunbot"
                  className="inputNone"
                  value={trader_name}
                  onChange={(e) => setTrader_name(e.target.value)}
                />
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Description:</label>
            <div className="form-control py-2">
                <textarea 
                  type="text"
                  className="inputNone w-100"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows={2}
                />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={win}
                      onChange={(e) => setWin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    WIN
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Loss:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={loss}
                      onChange={(e) => setLoss(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    LOSS
                    </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Win Rate:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="40"
                      className="inputNone"
                      value={win_rate}
                      onChange={(e) => setWin_rate(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      %
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Profit Share:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="2"
                      className="inputNone"
                      value={profit_share}
                      onChange={(e) => setProfit_share(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      %
                    </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Join Days:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="365"
                      className="inputNone"
                      value={join}
                      onChange={(e) => setJoin(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      Days
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="100/1000"
                      className="inputNone"
                      value={copiers}
                      onChange={(e) => setCopiers(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>AUM (USDT):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      className="inputNone"
                      value={aum}
                      onChange={(e) => setAum(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      USDT
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Price:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      className="inputNone"
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                      USD
                    </div>
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Badge:</label>
            <Select 
                options={badgeoption} 
                value={badgeoption.find((opt) => opt.value === badge_color)}
                onChange={(selected) => {
                  setBadge_color(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
            <div
              className={`myBtn w-100 text-center mt-3 ${disable ? 'disabled' : ''}`}
              style={{ paddingTop: '12px', paddingBottom: '12px' }}
              onClick={() => {if (disable) return; setIsOpen(false);setIsOpen1(true);}}>
              Next
            </div>
        </Modal>
        <Modal
            isOpen={modalIsOpen1}
            onRequestClose={() => setIsOpen1(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>Add expert</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Rank:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1"
                      className="inputNone"
                      value={rank}
                      onChange={(e) => setRank(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Closed Portfolios:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={portfolio}
                      onChange={(e) => setPortfolio(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Mock Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="500"
                      className="inputNone"
                      value={mock}
                      onChange={(e) => setMock(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Total Copiers:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={totalCopiers}
                      onChange={(e) => setTotalCopiers(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Margin Balance:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder=""
                      className="inputNone"
                      value={margin}
                      onChange={(e) => setMargin(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Copiers PnL(USDT):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={pnl}
                      onChange={(e) => setPnl(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Lock Period:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="30D"
                      className="inputNone"
                      value={lock}
                      onChange={(e) => setLock(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Min. Copy Amount:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="text"
                      placeholder="10/10"
                      className="inputNone"
                      value={min}
                      onChange={(e) => setMin(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Performance:</label>
            <div className="d-flex align-items-center justify-content-between">
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>7D</label>
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>30D</label>
              <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>90D</label>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>ROI:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={sevenRoi}
                      onChange={(e) => setSevenRoi(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyRoi}
                      onChange={(e) => setThirtyRoi(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyRoi}
                      onChange={(e) => setNinetyRoi(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>PnL (USDT):</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={sevenPnl}
                      onChange={(e) => setSevenPnl(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyPnl}
                      onChange={(e) => setThirtyPnl(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyPnl}
                      onChange={(e) => setNinetyPnl(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Sharpe Ratio:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={sevenRatio}
                      onChange={(e) => setSevenRatio(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={thirtyRatio}
                      onChange={(e) => setThirtyRatio(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="200"
                      className="inputNone"
                      value={ninetyRatio}
                      onChange={(e) => setNinetyRatio(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Win Rate:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={sevenWinRate}
                      onChange={(e) => setSevenWinRate(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={thirtyWinRate}
                      onChange={(e) => setThirtyWinRate(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={ninetyWinRate}
                      onChange={(e) => setNinetyWinRate(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>MDD:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={sevenMdd}
                      onChange={(e) => setSevenMdd(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={thirtyMdd}
                      onChange={(e) => setThirtyMdd(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="45"
                      className="inputNone"
                      value={ninetyMdd}
                      onChange={(e) => setNinetyMdd(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Total Positions:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={sevenPosition}
                      onChange={(e) => setSevenPosition(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={thirtyPosition}
                      onChange={(e) => setThirtyPosition(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="7"
                      className="inputNone"
                      value={ninetyPosition}
                      onChange={(e) => setNinetyPosition(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <label className="mt-1 mb-1" style={{fontSize: '14px'}}>Profitable Positions:</label>
            <div className="row">
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={sevenProfit}
                      onChange={(e) => setSevenProfit(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={thirtyProfit}
                      onChange={(e) => setThirtyProfit(e.target.value)}
                    />
                </div>
              </div>
              <div className="col-4">
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="4"
                      className="inputNone"
                      value={ninetyProfit}
                      onChange={(e) => setNinetyProfit(e.target.value)}
                    />
                </div>
              </div>
            </div>
            <div className={`myBtn w-100 text-center mt-3 ${disable1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable1 ? AddCopytrade : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default Copyexpert